module.exports = __webpack_public_path__ + "img/boleto.e5ee6bdb.png";